import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { deleteData, getData, patchData, postData } from "src/utils/axios/serverHelper";
import { SYS3010_R01Dto } from "./Dto_SYS3010_R01";
import { SYS3010_R01Filter } from "./Store_SYS3010_R01";
import { encryptPassword } from "src/utils/auth/passwordEncrypt";

const baseUrl = `${config.apiUrl}/SYS3010_R01`;

const isSha384Hash = (value?: string | null): boolean => {
    if (!value) return false;
    return /^[0-9a-fA-F]{96}$/.test(value);
};

const withEncryptedPassword = (data: SYS3010_R01Dto[]) =>
    data.map(item => ({
        ...item,
        password:
            item.password && item.password.trim().length > 0 && !isSha384Hash(item.password)
                ? encryptPassword(item.password)
                : item.password
    }));

export const getSYS3010_R01List = async (option: string, params: Partial<SYS3010_R01Filter>, listLength: number = 0) => {
    const url = `${baseUrl}/${option}`

    return await getData<ResponseDto<SYS3010_R01Dto[]>>(url, {
        params: {
            ...params,
            listLength
        }
    });
}


export const getSYS3010_R01AllCount = async (params: Partial<SYS3010_R01Filter>) => {
    const url = `${baseUrl}/allCount`;
    return await getData<ResponseDto<number>>(url, {
        params: {
            ...params
        }
    });
}

export const postSYS3010_R01 = async (data: SYS3010_R01Dto[]) => {
    const url = `${baseUrl}`;

    return await postData<SYS3010_R01Dto[], ResponseDto<SYS3010_R01Dto[]>>(url, withEncryptedPassword(data));
}

export const patchSYS3010_R01 = async (data: SYS3010_R01Dto[]) => {
    const url = `${baseUrl}`;

    return await patchData<SYS3010_R01Dto[], ResponseDto<SYS3010_R01Dto[]>>(url, withEncryptedPassword(data));
}

export const deleteSYS3010_R01 = async (userId: string) => {
    let url = `${baseUrl}/${userId}`;

    return await deleteData<ResponseDto<any>>(url);
}

export const downloadExcel_SYS3010_R01 = async (option: string, params: Partial<SYS3010_R01Filter>, listLength: number = 0) => {
    const url = `${baseUrl}/excel/${option}`;

    return await getData<ResponseDto<string>>(url, {
        params: {
            ...params,
            listLength
        }
    });
}